let defaultCoverageForm = {
    direccion: '',
    cp: '',
}

export default defaultCoverageForm